'use client';
import styles from './Labels.module.scss';
import { get, map } from 'lodash';
import Image from '@/grandus-utils/wrappers/image/Image';
import filter from 'lodash/filter';
import { useTranslation } from '@/app/i18n/client';

const generateStyles = (bgColor, textColor) => {
  const styles = {};

  if (bgColor) {
    styles.background = bgColor;
  }

  if (textColor) {
    styles.color = textColor;
  }
  return styles;
};

const stylesByLabelType = new Map([
  [1, styles.base],
  [2, styles.discount],
]);

const Labels = ({
  labels,
  discount,
  showText = true,
  className = '',
  isCard = 'false',
}) => {
  const { t } = useTranslation();
  const photoLabels = filter(labels, label => label?.photo);
  const baseLabels = filter(labels, label => !label.photo && label.type === 1);

  return (
    <div className={`${styles.labels} ${className}`}>
      <div className={styles.baseLabels}>
        {map(baseLabels, (label, index) => {
          const customStyles = generateStyles(
            label.backgroundColor,
            label.textColor,
          );
          return (
            <div
              key={label?.name ?? `label_${index}`}
              className={`${styles.label} ${
                stylesByLabelType.get(label.type) ?? ''
              }`}
              style={customStyles}
            >
              {label.photo ? (
                <Image
                  photo={label?.photo}
                  type={'png'}
                  width={80}
                  height={80}
                  alt={label?.name ?? 'label'}
                  className="w-[40px] h-auto"
                />
              ) : (
                ''
              )}
              {!label.photo || showText ? <span>{label?.name}</span> : null}
            </div>
          );
        })}
        {discount !== null && isCard ? (
          <div className={`${styles.label} ${styles.discount} absolute righ-2`}>
            <div
              className={`${styles.label} w-16 h-16 bg-discount2 text-white`}
            >
              {t('product.discount')} <br />
              {discount}
            </div>
          </div>
        ) : null}
      </div>

      <div className={styles.photoLabels}>
        {map(photoLabels, (label, index) => {
          const customStyles = generateStyles(
            label.backgroundColor,
            label.textColor,
          );
          return (
            <div
              key={label?.name ?? `label_${index}`}
              className={`${styles.label} ${
                stylesByLabelType.get(label.type) ?? ''
              }`}
              style={customStyles}
            >
              {label.photo ? (
                <Image
                  photo={label?.photo}
                  type={'png'}
                  width={80}
                  height={80}
                  alt={label?.name ?? 'label'}
                  className="w-[40px] h-auto"
                />
              ) : (
                ''
              )}
              {!label.photo || showText ? <span>{label?.name}</span> : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Labels;
